export default "/_next/static/images/8269236ac69f059b01ffe617bbe7dba3.png";